module.exports = __webpack_public_path__ + "static/media/appstore.ad6661fe.svg";